/** Rail colour per state — shared with the detail page's timeline dots */
export const stateColor: { [key: string]: string } = {
    PENDING: '#c98a12',
    APPROVED: '#2f6bff',
    COMPLETED: '#15a66a',
    ERROR: '#e0457b',
    REJECTED: '#e07b1a',
    CLOSED: '#8a93a6',
};

export const STATE_ORDER = ['PENDING', 'APPROVED', 'COMPLETED', 'ERROR', 'REJECTED', 'CLOSED'];
export const CHANGE_TYPES = ['CREATE', 'MODIFY', 'DELETE'];

/**
 * Matches the antd preset each change-type tag uses in Common/Tags —
 * success / processing / error — so a row's border reads as its change type.
 */
export const changeTypeColor: { [key: string]: string } = {
    CREATE: '#52c41a',
    MODIFY: '#1677ff',
    DELETE: '#ff4d4f',
};
export const DEFAULT_CHANGE_TYPE_COLOR = '#8b93ab';

const niceCase = (value: string) =>
    value ? value.charAt(0) + value.slice(1).toLowerCase() : value;

export const stateOptions = STATE_ORDER.map((value) => ({ value, label: niceCase(value) }));
export const changeTypeOptions = CHANGE_TYPES.map((value) => ({ value, label: niceCase(value) }));

/**
 * No state among them. A state is something to filter the list down to, not to
 * order it by — the order would only ever be alphabetical, which says nothing
 * about how the states relate.
 */
export const sortOptions: { value: string; label: string; field: string; order: 'ASC' | 'DESC' }[] = [
    { value: 'id:DESC', label: 'Newest first', field: 'id', order: 'DESC' },
    { value: 'id:ASC', label: 'Oldest first', field: 'id', order: 'ASC' },
    { value: 'modified:DESC', label: 'Recently modified', field: 'modified', order: 'DESC' },
    { value: 'change_type:ASC', label: 'Change type', field: 'change_type', order: 'ASC' },
];
